module.exports = __webpack_public_path__ + "static/img/qrcode2.a761ffb2.png";